import { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { ActionButton } from './ActionButton';
import { Pencil, Trash2, Plus, FileText, MoreHorizontal } from 'lucide-react';

export function ObjectBottomSheet({
  title,
  subtitle,
  isEditable,
  onClose,
  onEdit,
  onDelete,
  onAddLine,
  onPassport,
}) {
  const [isMoving, setIsMoving] = useState(false);

  return (
    <BottomSheet
      title={title}
      onClose={onClose}
      open={true}
      isEditable={isEditable}
      onDelete={() => { onDelete(); onClose(); }}
    >
      {/* Подзаголовок если есть (для опоры — координаты) */}
      {subtitle && (
        <p style={{ fontSize: '13px', color: '#888', marginBottom: '16px', marginTop: '-8px' }}>
          {subtitle}
        </p>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

        <button
          onClick={() => { onPassport(); /*onClose();*/ }}
          style={buttonStyle('primary')}
        >
          <FileText size={16} />
          Паспорт
        </button>

        {isEditable && (
            <>
          <ActionButton 
            label="Редактировать" 
            icon={<Pencil size={16} />}
            onClick={() => { onEdit(); onClose(); }}
          />

          <ActionButton 
            label="Добавить линию"
            icon={<Plus size={16} />}
            onClick={() => { onAddLine(); onClose(); }}
          />
        </>
        )}

        

      </div>
    </BottomSheet>
  );
}

function buttonStyle(variant) {
  const variants = {
    default: { background: '#f5f5f5', color: '#1a1a1a' },
    primary: { background: '#eff6ff', color: '#1d4ed8' },
    danger: { background: '#fff0f0', color: '#ef4444' },
  };
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '14px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    width: '100%',
    ...variants[variant]
  };
}